module.exports = __webpack_public_path__ + "static/item-section-4-cc5f1b439b2d755db58aeaa7f3086a11.png";